import React, { useEffect, useState } from "react";
import {
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  CartesianGrid,
  BarChart,
  Bar,
  LabelList,
} from "recharts";
import { handleMonth, translate } from "../../../../../utils/Common";
import { usePackages } from "../../../../../hooks/usePackages";
import Spinner from "../../../../../components/Spinner";
import { LuBox } from "react-icons/lu";
import PlatformSearchList from "../../../../../components/PlatformSearchList";
import { useForm } from "react-hook-form/dist/index.ie11";
import styles from "./Charts.module.css";

const PercentageOccupation = (props) => {
  const { yearSelect, canReadFilters = true } = props;
  const { getStatsOccupationTotal } = usePackages();
  const { register, errors, setValue } = useForm();

  const [data, setData] = useState(null);
  const [platformSelect, setPlatformSelect] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const getData = async () => {
    setIsLoading(true);
    const signal = new AbortController().signal;
    const result = await getStatsOccupationTotal(signal, {
      year: Number(yearSelect),
      lockerId: platformSelect?.boxitLocationId ? Number(platformSelect?.boxitLocationId) : null,
    });
    setIsLoading(false);

    if (result.length > 0) {
      const formattedData = result.map((item) => ({
        month: handleMonth(item?.monthCurrent),
        total: item?.result,
        totalPercentage: `${parseFloat(item?.result).toFixed(2)}%`,
      }));
      setData(formattedData);
    } else {
      setData([]);
    }
  };

  useEffect(() => {
    if (yearSelect !== null) {
      if (canReadFilters && platformSelect === null) return;
      getData();
    }
  }, [yearSelect, platformSelect, canReadFilters]);

  return (
    <div className={styles.chartSection}>
      <div className={styles.chartHeaderRow}>
        <h6 className={styles.chartTitle}>
          {isLoading ? (
            <span><Spinner type={1} /></span>
          ) : (
            <LuBox size={20} aria-hidden />
          )}{" "}
          {translate("global.percentageOccupationTotal")} -{" "}
          <span className={styles.chartTitleAccent}>{yearSelect}</span>
        </h6>
      </div>

      <hr className={styles.chartDivider} />

      {canReadFilters && (
        <div className={styles.chartFilters}>
          <div className={styles.selectWrapper} style={{ width: "250px" }}>
            <PlatformSearchList
              register={register}
              errors={errors}
              setPlatformSelect={setPlatformSelect}
              platfSelect={platformSelect}
              valueId="plataforma"
              readOnly={false}
              setValue={setValue}
              isClearable
            />
          </div>
        </div>
      )}

      {yearSelect !== null ? (
        data === null ? null : data.length === 0 ? (
          <div className={styles.noDataCard}>{translate("global.noDataToView")}</div>
        ) : (
          <div className={styles.chartContainerTall}>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={data}>
                <CartesianGrid strokeDasharray="3 3" stroke="var(--border-light)" />
                <XAxis dataKey="month" stroke="var(--text-secondary)" />
                <YAxis stroke="var(--text-secondary)" />
                <Tooltip />
                <Legend />
                <Bar
                  dataKey="total"
                  fill="var(--color-primary)"
                  name={translate("global.ocupationPercentage")}
                >
                  <LabelList
                    dataKey="totalPercentage"
                    position="top"
                    fill="var(--text-primary)"
                    fontSize={12}
                  />
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        )
      ) : null}
    </div>
  );
};

export default PercentageOccupation;
